const isBase64UrlSegment = (segment: string): boolean =>
  segment.length > 0 && segment.length % 4 !== 1 && /^[A-Za-z0-9_-]+$/.test(segment);

const decodeBase64UrlJson = (segment: string): unknown | null => {
  const normalized = segment.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), '=');

  try {
    const decoded = atob(padded);
    const bytes = Uint8Array.from(decoded, character => character.charCodeAt(0));
    return JSON.parse(new TextDecoder('utf-8', { fatal: true }).decode(bytes));
  } catch {
    return null;
  }
};

const hasAdminOriginalScope = (payload: unknown): boolean =>
  typeof payload === 'object' &&
  payload !== null &&
  !Array.isArray(payload) &&
  (payload as Record<string, unknown>).originalScope === 'admin';

export const parseIsAdmin = (token: unknown): boolean => {
  if (typeof token !== 'string') return false;

  const segments = token.split('.');
  if (segments.length !== 3 || !segments.every(isBase64UrlSegment)) return false;

  return hasAdminOriginalScope(decodeBase64UrlJson(segments[1]));
};
